import React from 'react';
import { useNavigate } from 'react-router-dom';
import { setFrameChoice } from './globalState';
import './App.css';
import BackButton from './BackButton';

function FrameSelection() {
  /*
  FrameSelection lets the user pick a license plate frame style before the
  plate upload/photography workflow begins.

  Chrome or Black → choice recorded in sessionStorage → /upload-plates
  Custom          → choice recorded in sessionStorage → /upload-frame
                    (user must supply their own frame files first, then
                     continues to /upload-plates for the plate itself)
  */
  const navigate = useNavigate();

  const handleSelect = (choice) => {
    setFrameChoice(choice);
    if (choice === 'Custom') {
      navigate('/upload-frame');
    } else {
      navigate('/upload-plates');
    }
  };

  const handleSupportClick = () => navigate('/support');

  return (
    <div className="FrameSelection">
      <h1 className="FrameSelection-title">Select your frame style</h1>

      <div className="FrameSelection-options">
        <div className="FrameSelection-item" onClick={() => handleSelect('Chrome')}>
          <span className="FrameSelection-label">Chrome</span>
          <img src="/components/icons/Chrome_Plate_01.png" alt="Chrome frame" className="FrameSelection-custom-image" />
        </div>

        <div className="FrameSelection-item" onClick={() => handleSelect('Black')}>
          <span className="FrameSelection-label">Black</span>
          <img src="/components/icons/Black_Plate_01.png" alt="Black frame" className="FrameSelection-custom-image" />
        </div>

        <div className="FrameSelection-item" onClick={() => handleSelect('Custom')}>
          <span className="FrameSelection-label">Custom</span>
          <img src="/components/icons/Custom_Plate_01.png" alt="Custom frame" className="FrameSelection-custom-image" />
        </div>
      </div>

      <div className="FrameSelection-support">
        Questions?{' '}
        <span className="support-link" onClick={handleSupportClick}>Click here</span>
        {' '}to reach out to our support team directly.
      </div>
      <BackButton />
    </div>
  );
}

export default FrameSelection;
